// src/data/medicalDeviceData.js

// NOT: Bu yapı, cihaz ekleme formundaki marka/model seçim kutularını doldurmak için kullanılacaktır.
// Şimdilik örnek markalar ve modeller eklenmiştir.
export const medicalDeviceData = {
  "Marka A": [
    { model: "Model X1" },
    { model: "Model X2" },
    { model: "Model X3 Pro" }
  ],
  "Marka B": [
    { model: "Cihaz T-100" },
    { model: "Cihaz T-200" }
  ],
  "Marka C": [
    { model: "Medikal Ünite 5" },
    { model: "Medikal Ünite 7 Plus" }
  ],
  "Diğer": [
    { model: "Genel Cihaz" }
  ]
};